export enum DIALOG_EVENT_CONFIG {
  RARE_CASE = 'RARE_CASE',
  GUIDE = 'GUIDE',
  CASE_SHOP = 'CASE_SHOP',
}
